import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogCloseButton,
  AlertDialogHeader,
  AlertDialogBody,
  Button,
  Flex,
  useTheme,
} from "@chakra-ui/react";
import React, { useRef } from "react";
const ChangeStatusPopup = ({ isOpen, onClose, onClickStatusChange, text }) => {
  const cancelRef = useRef();
  const { primaryBlue, primaryBlueLight } = useTheme().colors.pallete;

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
      size={"sm"}
      isCentered
    >
      <AlertDialogOverlay />

      <AlertDialogContent>
        <AlertDialogHeader></AlertDialogHeader>

        <AlertDialogCloseButton />

        <AlertDialogBody
          textAlign={"center"}
          fontWeight={600}
          fontSize="1.1rem"
        >
          Are you sure want to change status of {text} ??
        </AlertDialogBody>
        <Flex
          flexWrap={"wrap"}
          justifyContent={"center"}
          alignItems={"center"}
          p={6}
        >
          <Button
            ref={cancelRef}
            fontWeight={500}
            color={primaryBlue}
            onClick={onClose}
            flex={0.5}
          >
            No
          </Button>
          <Button
            ml={3}
            fontWeight={500}
            color="white"
            flex={0.5}
            bg={primaryBlue}
            onClick={onClickStatusChange}
            _hover={{ bg: primaryBlueLight }}
          >
            Yes
          </Button>
        </Flex>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ChangeStatusPopup;
